import React from 'react';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import ExperienceList from '../../ExperienceList/ExperienceList';
import FileAttachment from '../../FileAttachment/FileAttachment';

const QuestionAnswerItem = ({ qa, index }) => {
  const { question, answer, type, attachments } = qa;

  // Type-aware rendering
  let renderedAnswer = "-";
  if (type === "date") {
    renderedAnswer = answer ? dayjs(answer).format('YYYY-MM-DD') : "-";
  } else if (type === "file") {
    renderedAnswer = <FileAttachment attachments={attachments} />;
  } else if (type === "separated-list") {
    let items = [];
    if (Array.isArray(answer)) items = answer;
    else if (typeof answer === "string")
      items = answer.split(/,+/).map(v => v.trim()).filter(Boolean);
    renderedAnswer = items.length
      ? (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {items.map((v, idx) => <li key={idx}>{v}</li>)}
        </ul>
      ) : "-";
  } else if (type === "experience-list") {
    renderedAnswer = <ExperienceList value={answer} />;
  } else {
    renderedAnswer = answer || "-";
  }

  return (
    <ListItem
      alignItems="flex-start"
      sx={{
        background: index % 2 ? '#fafafa' : 'white',
        borderRadius: 1,
        mb: 1,
        boxShadow: 0,
        flexDirection: 'column',
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Typography variant="body2" fontWeight="bold">
          Q{index + 1}: {question}
        </Typography>
        <Box sx={{ ml: 2, mt: 0.5 }}>
          {renderedAnswer}
        </Box>
      </Box>
    </ListItem>
  );
};

export default QuestionAnswerItem;
